// extracted by mini-css-extract-plugin
export default {"header":"header_header__M0KAT","back":"header_back__z42FZ","rotate":"header_rotate__nH+ei"};